export const Overworld = {
    "Death Mountain Crater": {"shorthand": ["dmc"]},
    "Death Mountain Trail": {"shorthand": ["dmt"]},
    "Goron City": {"shorthand": ["gc"]},
    "Gerudo Fortress": {"shorthand": ["gf", "fortress"]},
    "Gerudo Valley": {"shorthand": ["gv", "valley"]},
    "Hyrule Castle": {"shorthand": ["hc", "castle"]},
    "Hyrule Field": {"shorthand": ["hf"]},
    "Kokiri Forest": {"shorthand": ["kf"]},
    "Lake Hylia": {"shorthand": ["lh", "lake", "ly" /* I'm weird and type 'ly' */]},
    "Lon Lon Ranch": {"shorthand": ["llr", "lon", "lonlon"]},
    "Lost Woods": {"shorthand": ["lw"]},
    "Outside Ganon's Castle": {"shorthand": ["ogc"]},
    "Sacred Forest Meadow": {"shorthand": ["sfm"]},
    "Thieves' Hideout": {"shorthand": ["th", "hideout"]},
    "Temple of Time": {"shorthand": ["tot"]},
    "Zora's Domain": {"shorthand": ["zd"]},
    "Zora's Fountain": {"shorthand": ["zf"]},
    "Zora's River": {"shorthand": ["zr"]},
    "Market": {"shorthand": ["hm" /* (H)yrule (M)arket */]},
    "Kakariko Village": {"shorthand": ["kak"]},
    "Graveyard": {"shorthand": ["grave", "gy", "ihatedampe"]},
    "Haunted Wasteland": {"shorthand": ["wasteland", "hw"]},
    "Desert Colossus": {"shorthand": ["colossus", "gdc" /* (G)erudo (D)esert (C)olossus */]}
};

export const Dungeons = {
    "Deku Tree": {"shorthand": ["deku", "dt"]},
    "Dodongo's Cavern": {"shorthand": ["dc"]},
    "Jabu Jabu's Belly": {"shorthand": ["jabu", "jjb", "zfd"]},
    "Bottom of the Well": {"shorthand": ["botw"]},
    "Forest Temple": {"shorthand": ["forest", "sfmd"]},
    "Fire Temple": {"shorthand": ["fire", "dmcd"]},
    "Water Temple": {"shorthand": ["water", "lhd"]},
    "Shadow Temple": {"shorthand": ["shadow", "istillhatedampe"]},
    "Spirit Temple": {"shorthand": ["spirit", "gdcd"]},
    "Ice Cavern": {"shorthand": ["ice", "ic"]},
    "Gerudo Training Ground": {"shorthand": ["gtg"]},
    "Inside Ganon's Castle": {"shorthand": ["igc"]}
};

export const Items = {
    "Triforce Piece": {"shorthand": ["triforce", "tp"]},
    "Magic Meter": {"shorthand": ["magic", "mm"]},
    "Double Defense": {"shorthand": ["dd"]},
    "Slingshot": {"shorthand": ["ss"]},
    "Boomerang": {"shorthand": ["rang"]},
    "Bow": {"shorthand": []},
    "Bomb Bag": {"shorthand": ["bombs"]},
    "Bombchus": {"shorthand": ["chus"]},
    "Hookshot": {"shorthand": ["longshot", "hs"]},
    "Progressive Strength": {"shorthand": ["strength", "gb", "silvers", "golds"]},
    "Progressive Scale": {"shorthand": ["scale"]},
    "Megaton Hammer": {"shorthand": ["hammer"]},
    "Iron Boots": {"shorthand": ["irons"]},
    "Hover Boots": {"shorthand": ["hovers"]},
    "Kokiri Sword": {"shorthand": ["ks", "sword"]},
    "Giants Knife": {"shorthand": ["knife"]},
    "Biggoron Sword": {"shorthand": ["bs"]},
    "Master Sword": {"shorthand": ["ms", "master"]},
    "Deku Shield": {"shorthand": []},
    "Hylian Shield": {"shorthand": ["shield"]},
    "Mirror Shield": {"shorthand": ["mirror"]},
    "Farores Wind": {"shorthand": ["farore", "fw"]},
    "Nayrus Love": {"shorthand": ["nayru", "nl"]},
    "Dins Fire": {"shorthand": ["dins"]},
    "Fire Arrows": {"shorthand": ["firearrows", "fires"]},
    "Ice Arrows": {"shorthand": ["icearrows", "ices", "bfa" /* (B)lue (F)ire (A)rrows */]},
    "Light Arrows": {"shorthand": ["lights", "la", "lightarrows"]},
    "Lens of Truth": {"shorthand": ["lens"]},
    "Progressive Ocarina": {"shorthand": ["fo", "oot"]},
    "Goron Tunic": {"shorthand": ["firetunic", "gt", "gorontunic"]},
    "Zora Tunic": {"shorthand": ["watertunic", "zt", "zoratunic"]},
    "Zeldas Lullaby": {"shorthand": ["zl", "lullaby"]},
    "Eponas Song": {"shorthand": ["epona", "eponas"]},
    "Sarias Song": {"shorthand": ["saria", "sarias"]},
    "Suns Song": {"shorthand": ["suns"]},
    "Song of Time": {"shorthand": ["sot"]},
    "Song of Storms": {"shorthand": ["storms", "sos"]},
    "Minuet of Forest": {"shorthand": ["minuet"]},
    "Bolero of Fire": {"shorthand": ["bolero"]},
    "Serenade of Water": {"shorthand": ["serenade"]},
    "Requiem of Spirit": {"shorthand": ["requiem"]},
    "Nocturne of Shadow": {"shorthand": ["nocturne"]},
    "Prelude of Light": {"shorthand": ["prelude"]},
    "Bottle": {"shorthand": []},
    "Ruto's Letter": {"shorthand": ["ruto", "letter"]},
    "Stone of Agony": {"shorthand": ["oldplasticbrick"]},
    "Gerudo Membership Card": {"shorthand": ["gerudocard"]},
    "Progressive Wallet": {"shorthand": ["wallet"]},
    "Deku Stick Capacity": {"shorthand": ["stickupgrade"]},
    "Deku Nut Capacity": {"shorthand": ["nutupgrade"]},
    "Poachers Saw": {"shorthand": []},
    "Broken Sword": {"shorthand": []},
    "Prescription": {"shorthand": []},
    "Eyeball Frog": {"shorthand": ["frog!!"]},
    "Eyedrops": {"shorthand": []},
    "Claim Check": {"shorthand": []},

    "Forest Small Key": {"shorthand": []},
    "Forest Small Key Ring": {"shorthand": []},
    "Forest Boss Key": {"shorthand": []},
    "Fire Small Key": {"shorthand": []},
    "Fire Small Key Ring": {"shorthand": []},
    "Fire Boss Key": {"shorthand": []},
    "Water Small Key": {"shorthand": []},
    "Water Small Key Ring": {"shorthand": []},
    "Water Boss Key": {"shorthand": []},
    "Shadow Small Key": {"shorthand": []},
    "Shaodw Small Key Ring": {"shorthand": []},
    "Shadow Boss Key": {"shorthand": []},
    "Spirit Small Key": {"shorthand": []},
    "Spirit Small Key Ring": {"shorthand": []},
    "Spirit Boss Key": {"shorthand": []},
    "GTG Small Key": {"shorthand": []},
    "GTG Small Key Ring": {"shorthand": []},
    "BOTW Small Key": {"shorthand": []},
    "BOTW Small Key Ring": {"shorthand": []},
    "Ganon's Castle Small Key": {"shorthand": []},
    "Ganon's Castle Small Key Ring": {"shorthand": []},
    "Boss Key": {"shorthand": ["bk"]},

    "Barren": {"shorthand": ["foolish", "dead"]},
    "Way of the Hero": {"shorthand": ["woth"]},
    "Hero's Path": {"shorthand": ["hp"]}
};

export const Autofill = {
    "King Zora": {"shorthand": ["kz"]}
};

// This is not a list of every check in the game. That's a lot of effort, someone else can do that. This is instead a list of the common hints seen in OoTR (conditional always and conditional sometimes as of bdba663). Any Gold Skulltula rewards are treated separately.
export const Checks = {
    "Market 10 Big Poes": {"shorthand": ["poes"]},
    "Lost Woods Theater: Mask of Truth": {"shorthand": ["truthmask", "theater2"]},
    "Lost Woods Theater: Skull Mask": {"shorthand": ["skullmask", "theater1"]},
    "Hyrule Field Song from Ocarina of Time": {"shorthand": ["ootsong", "oots"]},
    "Hyrule Field Ocarina of Time Item": {"shorthand": ["ooti"]},
    "Kakariko Village Sheik": {"shorthand": ["kaksheik"]},
    "Death Mountain Trail Biggoron": {"shorthand": ["biggoron"]},
    "Zora's River Frogs Ocarina Game": {"shorthand": ["frogs2"]},
    "Zora's River Frogs Song in the Rain": {"shorthand": ["frogs1"]},
    "Hyrule Castle Great Fairy Reward": {"shorthand": ["hcfairy"]},
    "Outside Ganon's Castle Great Fairy Reward": {"shorthand": ["ogcfairy"]},
};

export const Skulls = {
    "10 Skulls": {"shorthand": ["10"]},
    "20 Skulls": {"shorthand": ["20"]},
    "30 Skulls": {"shorthand": ["30"]},
    "40 Skulls": {"shorthand": ["40"]},
    "50 Skulls": {"shorthand": ["50"]},
};

export const Places = {...Overworld, ...Dungeons, ...Checks, ...Skulls};
export const Locations = {...Overworld, ...Dungeons};
export const All = {...Places, ...Items, ...Autofill};
